import { Component, OnInit, Input } from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'tooltip',
    templateUrl: 'tooltip.html'
})

export class TooltipComponent implements OnInit {
    @Input() data;
    constructor(private router:Router) { }

    public goDetail(id: string){
        this.router.navigate(['/services', id]);
    }
    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/common/tooltip/tooltip.component.ts